const MuiCardContent = {
	styleOverrides: {
		root: {
			padding: 24,
		},
	},
};
export default MuiCardContent;
